<template>
  <div>
    <p class="border-t-4 border-green bg-green-lightest text-green-dark p-4 rounded-t shadow mb-4" role="alert" v-if="success" v-html="success"></p>
    <p class="border-t-4 border-red bg-red-lightest text-red-dark p-4 rounded-t shadow mb-4" role="alert" v-else-if="errors" v-html="errors"></p>
    <label for="card-element" class="mt-4 block uppercase tracking-wide text-charcoal-darker text-xs font-bold">
      Credit or debit card
    </label>
    <div class="flex items-stretch">
      <div ref="card"></div>
      <div class="p-4 rounded-4 bg-grey-light text-grey-darker text-center" v-if="loading">Loading...</div>
      <button class="p-4 rounded-r bg-blue hover:bg-blue-dark text-blue-lightest bg:text-white" @click="addCard" v-else>Add Card</button>
    </div>
    <p class="mt-4 text-sm">We do not store any of your credit card data. We only keep records of the card brand and last four digits for identification purposes, and the expiration date to make sure your card is still valid.</p>
  </div>
</template>

<script>
if (window.DTK) {
  let stripe = Stripe(window.DTK.stripeKey),
      elements = stripe.elements(),
      card = undefined
}

export default {
  props: ['user'],
  data() {
    return {
      errors: '',
      success: '',
      loading: false
    }
  },
  mounted() {
    card = elements.create('card')
    card.mount(this.$refs.card)
  },
  methods: {
    addCard(e) {
      this.loading = true
      stripe.createToken(card).then((result) => {
        if (result.error) {
          this.errors = result.error.message
          this.hasCardErrors = true
          this.$forceUpdate()
          this.loading = false
          return
        }

        axios.post('/api/v1/settings/source', {
          user: this.user.id,
          stripeId: this.user.stripe_id,
          stripeToken: result.token.id,
          last4: result.token.card.last4,
          expMonth: result.token.card.exp_month,
          expYear: result.token.card.exp_year,
          brand: result.token.card.brand
        }).then(({data}) => {
          this.loading = false
          if (data.success) {
            this.success = data.success
            this.errors = false
            this.$emit('success')
          } else {
            this.errors = data.error.message
            this.success = false
          }
        })
      })
    },
    changed(e) {
      if (e.error) {
        this.errors = e.error.message
      }
    }
  }
}
</script>

